import { DoctorOrderDetails, PrivateRoute } from '@/components';
import { RoutePath } from '@/config';
import { DoctorInnerPageLayout } from '@/layouts';

import { useParams } from 'react-router-dom';

export const DoctorOrderHistoryItemPage = () => {
  const { orderId } = useParams<{ orderId: string }>();

  if (!orderId) {
    return (
      <PrivateRoute redirectPath={RoutePath.DoctorLogin}>
        <DoctorInnerPageLayout />
      </PrivateRoute>
    );
  }

  return (
    <PrivateRoute redirectPath={RoutePath.DoctorLogin}>
      <DoctorInnerPageLayout>
        <DoctorOrderDetails orderId={Number(orderId)} />
      </DoctorInnerPageLayout>
    </PrivateRoute>
  );
};
